import React, { useEffect, useState } from "react";
import "./users.scss";
import { Col, Divider, Input, Row, Typography, Popconfirm, Button } from "antd";
import Icon from "../../../../components/icon/icon";
import { AdminGetUserRes } from "../../../../interfaces/user.interface";
import { HandleErrors } from "../../../../utils/handleErrors";
import {
  adminDeleteUserService,
  adminGetUsersService,
} from "../../../../services/user.service";
import {
  GetPermissionRes,
  GetRoleRes,
} from "../../../../interfaces/role.interface";
import { getRolesService } from "../../../../services/role.service";
import { AddUserModal } from "../../../../components/addUserModal/addUserModal";
import { UpdateRoleModal } from "../../../../components/updateRoleModal/updateRoleModal";
import { EditUserModal } from "../../../../components/editUserModal/editUserModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PermissionCode } from "../../../../enum/permission";

const Users = () => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const health = useSelector<RootState, string>((root) => root.app.health);

  const [addUserModal, setAddUserModal] = useState(false);
  const [updateUserModal, setUpdateUserModal] = useState(false);

  const [selectedUser, setSelectedUser] = useState<AdminGetUserRes>(
    {} as AdminGetUserRes
  );

  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [users, setUsers] = useState<AdminGetUserRes[]>([]);
  const [roles, setRoles] = useState<GetRoleRes[]>([]);
  useEffect(() => {
    getUsers();
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      const res = await getRolesService({});
      setRoles(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const getUsers = async () => {
    try {
      if(health == 'license-false'){
        return;
      }
      setLoading(true);
      const res = await adminGetUsersService({});
      setUsers(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const deleteUser = async (item: AdminGetUserRes) => {
    try {
      setDeleteLoading(true);
      await adminDeleteUserService({ id: item.id });
      await getUsers();
      setDeleteLoading(false);
    } catch (error) {
      HandleErrors(error);
      setDeleteLoading(false);
    }
  };

  return (
    <div className="AdminUsers">
      {health == "license-false" && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)" /* optional tint */,
          }}
        ></div>
      )}
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">کاربران</Typography.Text>
        </Col>
        <Col xs={10} md={4}>
          {userPermissions.find(
            (p) => p.code === PermissionCode.adminUserCreateNewUser
          ) && (
            <div
              className="btn-box"
              onClick={() => {
                setAddUserModal(true);
              }}
            >
              <Icon src="/assets/icons/Add - Circle.svg" />
              <Typography.Text className="title">افزودن کاربر</Typography.Text>
            </div>
          )}
        </Col>
      </Row>
      <div className="info-box">
        <Row>
          <Col>
            <Typography.Text className="title">مدیریت کاربران</Typography.Text>
          </Col>
        </Row>

        <Divider />

        {users.map((item) => {
          let temp = "";
          item.roles.map((roleId) => {
            const role = roles.find((e) => e.id == roleId);

            if (role && temp.length == 0) {
              temp += role.name;
            } else if (role && temp.length > 0) {
              temp += `,${role.name}`;
            }
          });

          return (
            <div className="user-box">
              <Row align={"middle"} justify={"space-between"}>
                <Col className="title-box">
                  <Typography.Text className="title">
                    مشخصات کاربر
                  </Typography.Text>
                </Col>
                <Col className="btn-box">
                  {userPermissions.find(
                    (p) => p.code === PermissionCode.adminUserUpdateUse
                  ) && (
                    <div
                      className="btn"
                      onClick={() => {
                        setSelectedUser(item);
                        setUpdateUserModal(true);
                      }}
                    >
                      <Icon src="/assets/icons/Pen.svg" />
                    </div>
                  )}
                  {userPermissions.find(
                    (p) => p.code === PermissionCode.adminUserDeleteUser
                  ) && (
                    <div className="del-btn">
                      <Popconfirm
                        title={`حذف کاربر: ${item.first_name} ${item.last_name}`}
                        description="کاربر شده قابل بازیابی نیست، مطمئن هستید؟"
                        onConfirm={() => {
                          deleteUser(item);
                        }}
                        onCancel={() => {}}
                        okText="حذف شود"
                        cancelText="لغو"
                      >
                        <Button type="text" loading={deleteLoading}>
                          <i className="las la-trash delete-icon"></i>
                        </Button>
                      </Popconfirm>
                    </div>
                  )}
                </Col>
              </Row>
              <Divider />
              <Row justify={"space-between"}>
                <Col md={12} xs={24}>
                  <div className="data-box">
                    <div className="title-box">
                      <Icon className="icon" src="/assets/icons/User.svg" />
                      <Typography.Text className="title">
                        نام و نام خانوادگی
                      </Typography.Text>
                    </div>
                    <Typography.Text className="value">
                      {item.first_name} {item.last_name}
                    </Typography.Text>
                  </div>
                </Col>
                <Col md={12} xs={24}>
                  <div className="data-box">
                    <div className="title-box">
                      <Icon className="icon" src="/assets/icons/Email.svg" />
                      <Typography.Text className="title">ایمیل</Typography.Text>
                    </div>
                    <Typography.Text className="value">
                      {item.email}{" "}
                    </Typography.Text>
                  </div>
                </Col>
                <Col md={12} xs={24}>
                  <div className="data-box">
                    <div className="title-box">
                      <Icon
                        className="icon"
                        src="/assets/icons/User - Profile.svg"
                      />
                      <Typography.Text className="title">
                        نام کاربری
                      </Typography.Text>
                    </div>
                    <Typography.Text className="value">
                      {item.username}{" "}
                    </Typography.Text>
                  </div>
                </Col>
                <Col md={12} xs={24}>
                  <div className="data-box">
                    <div className="title-box">
                      <Icon className="icon" src="/assets/icons/Verify.svg" />
                      <Typography.Text className="title">
                        نقش کاربری
                      </Typography.Text>
                    </div>
                    <Typography.Text className="value">{temp}</Typography.Text>
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      <AddUserModal
        show={addUserModal}
        onClose={() => {
          setAddUserModal(false);
          getUsers();
        }}
      />

      <EditUserModal
        user={selectedUser}
        show={updateUserModal}
        onClose={() => {
          setUpdateUserModal(false);
          getUsers();
        }}
      />
    </div>
  );
};

export default Users;
